import React from 'react';
import { FormattedMessage } from 'react-intl';
import { string, array } from 'prop-types';
import Card from '../../../../components/Card/Card';
import OfferStatsTable from '../../../../components/Offer/OfferStatsTable';

const propTypes = {
  statistics: array.isRequired,
  currency: string,
};

const defaultProps = {
  statistics: [],
};

const OfferLandingsList = ({ statistics, currency }) => (
  <Card collapsing>
    <Card.Header>
      <FormattedMessage id="offer.conversions.title" defaultMessage="Conversions" />
    </Card.Header>
    <Card.Body className="no-padding">
      <OfferStatsTable statistics={statistics} currency={currency} />
    </Card.Body>
  </Card>
);

OfferLandingsList.propTypes = propTypes;
OfferLandingsList.defaultProps = defaultProps;

export default OfferLandingsList;
